<template>
  <div class="animated fadeIn">
    <div class="container lambo-cockpit">
      <div class="row">
        <div class="col-xl">
          <div ref="cockpit-and-filter" class="card">
            <div class="card-header" >
              <div class="form-row">
                <div class="form-group col-md-3">
                  <treeselect :placeholder="$t('Webportal.SurveyFilter.Placeholder')"
                              ref="surveysTreeselect"
                              instance-id="Surveys"
                              v-model="selection.Surveys"
                              valueFormat="object"
                              :clearable="false"
                              :options="optionsdata.Surveys"
                              :auto-load-root-options="false"
                              :searchable="false"
                              :showCount="true"
                              showCountOf="LEAF_DESCENDANTS"
                              @input="handleSurveyInput"
                              :disabled="isLoading" />
                </div>

                <div class="form-group col-md-2">
                  <treeselect :placeholder="$t('Webportal.WaveFilter.Placeholder')"
                              ref="waveTreeselect"
                              instance-id="Waves"
                              v-model="selection.Waves"
                              :options="optionsdata.Waves"
                              :auto-load-root-options="false"
                              :multiple="true"
                              :searchable="true"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              :flat="true"
                              showCountOf="LEAF_DESCENDANTS"
                              @select="handleSelect"
                              @deselect="handleDeselect"
                              @close="handleClose"
                              @input="handleInput"
                              :disabled="!isWaveFilterEnabled || isLoading" />
                </div>
                
               <div class="form-group col-md-2">
                  <treeselect :placeholder="$t('Webportal.BrandFilter.Placeholder')"
                              ref="brandTreeselect"
                              instance-id="Brand"
                              v-model="selection.Brand"
                              :options="optionsdata.Brand"
                              :auto-load-root-options="false"
                              :multiple="true"
                              :searchable="true"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              :flat="true"
                              showCountOf="LEAF_DESCENDANTS"
                              :disabled="isLoading"
                              :disable-branch-nodes="true"
                              @select="handleSelect"
                              @deselect="handleDeselect"
                              @close="handleClose"
                              @input="handleInput" />
                </div>


                <div class="form-group col-md">
                  <treeselect :placeholder="$t('Webportal.CountryFilter.Placeholder')"
                              ref="countryTreeselect"
                              instance-id="Country"
                              v-model="selection.Country"
                              :options="optionsdata.Country"
                              :auto-load-root-options="false"
                              :multiple="true"
                              :searchable="true"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              :flat="true"
                              showCountOf="LEAF_DESCENDANTS"
                              @select="handleSelect"
                              @deselect="handleDeselect"
                              @close="handleClose"
                              @input="handleInput"
                              :disabled="!isCountryFilterEnabled || isLoading" />
                </div>

                <div class="form-group col-md-2">
                  <treeselect :placeholder="$t('Webportal.RegionFilter.Placeholder')"
                              ref="regionTreeselect"
                              instance-id="Region"
                              v-model="selection.Region"
                              :options="optionsdata.Region"
                              :auto-load-root-options="false"
                              :multiple="true"
                              :searchable="true"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              :flat="true"
                              showCountOf="LEAF_DESCENDANTS"
                              @select="handleSelect"
                              @deselect="handleDeselect"
                              @close="handleClose"
                              @input="handleInput"
                              :disabled="!isRegionFilterEnabled || isLoading" />
                </div>

                <div class="form-group col-md">
                  <treeselect :placeholder="$t('Webportal.HoldingGroupNameFilter.Placeholder')"
                              ref="holdingGroupNameTreeselect"
                              instance-id="HoldingGroupName"
                              v-model="selection.HoldingGroupName"
                              :options="optionsdata.HoldingGroupName"
                              :auto-load-root-options="false"
                              :multiple="true"
                              :searchable="true"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              :flat="true"
                              showCountOf="LEAF_DESCENDANTS"
                              @select="handleSelect"
                              @deselect="handleDeselect"
                              @close="handleClose"
                              @input="handleInput"
                              :disabled="!isHoldingGroupNameFilterEnabled || isLoading" />
                </div>
              </div>

              <div class="form-row">

                <div class="form-group col-md-2">
                  <treeselect :placeholder="$t('Webportal.DealerCodeFilter.Placeholder')"
                              ref="dealerCodeTreeselect"
                              instance-id="DealerCode"
                              v-model="selection.DealerCode"
                              :options="optionsdata.DealerCode"
                              :auto-load-root-options="false"
                              :multiple="true"
                              :searchable="true"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              :flat="true"
                              showCountOf="LEAF_DESCENDANTS"
                              @select="handleSelect"
                              @deselect="handleDeselect"
                              @close="handleClose"
                              @input="handleInput"
                              :disabled="!isDealerCodeFilterEnabled || isLoading" />
                </div>

                <div class="form-group col-md-3">
                  <treeselect :placeholder="$t('Webportal.DealerServiceFilter.Placeholder')"
                              ref="dealerServiceTreeselect"
                              instance-id="DealerService"
                              v-model="selection.DealerService"
                              :options="optionsdata.DealerService"
                              :auto-load-root-options="false"
                              :multiple="true"
                              :searchable="true"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              :flat="true"
                              showCountOf="LEAF_DESCENDANTS"
                              @select="handleSelect"
                              @deselect="handleDeselect"
                              @close="handleClose"
                              @input="handleInput"
                              :disabled="!isDealerServiceFilterEnabled || isLoading" />
                </div>

                <div class="form-group col-md-3">
                  <treeselect :placeholder="$t('Webportal.AreaFilter.Placeholder')"
                              ref="areaTreeselect"
                              instance-id="Area"
                              v-model="selection.Area"
                              :options="optionsdata.Area"
                              :auto-load-root-options="false"
                              :multiple="true"
                              :searchable="true"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              :flat="true"
                              showCountOf="LEAF_DESCENDANTS"
                              @select="handleSelect"
                              @deselect="handleDeselect"
                              @close="handleClose"
                              @input="handleInput"
                              :disabled="!isAreaFilterEnabled || isLoading" />
                </div>

             <!--   <div class="form-group col-md">
                  <treeselect :placeholder="$t('Webportal.AreaFilter.Placeholder')"
                              ref="prIDETreeselect"
                              instance-id="PrIDE"
                              v-model="selection.PrIDE"
                              :options="optionsdata.PrIDE"
                              :auto-load-root-options="false"
                              :multiple="true"
                              :searchable="true"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              :flat="true"
                              showCountOf="LEAF_DESCENDANTS"
                              @select="handleSelect"
                              @deselect="handleDeselect"
                              @close="handleClose"
                              @input="handleInput"
                              :disabled="!isPrIDEFilterEnabled || isLoading" />
                </div>-->

                

                <div class="form-group col-md">
                  <treeselect :placeholder="$t('Webportal.ClientLocationFilter.Placeholder')"
                              ref="clientLocationsTreeselect"
                              instance-id="ClientLocations"
                              v-model="selection.ClientLocations"
                              :options="optionsdata.ClientLocations"
                              :auto-load-root-options="false"
                              :multiple="true"
                              :searchable="true"
                              :disableFuzzyMatching="true"
                              :showCount="true"
                              :flat="true"
                              showCountOf="LEAF_DESCENDANTS"
                              @select="handleSelect"
                              @deselect="handleDeselect"
                              @close="handleClose"
                              @input="handleInput"
                              :disabled="!isClientLocationsFilterEnabled || isLoading">
                    <label  slot="option-label"
                            slot-scope="{ node, shouldShowCount, count, labelClassName }"
                            :class="labelClassName">
                      <span v-if="node.raw.isActive" v-b-tooltip.hover.nofade="toolTipDelay" :title="getLocationActiveText()">
                        <font-awesome-icon :icon="['far', 'lightbulb-on']" />
                      </span>
                      <span v-if="!node.raw.isActive" v-b-tooltip.hover.nofade="toolTipDelay" :title="getLocationInactiveText()">
                        <font-awesome-icon :icon="['far', 'lightbulb-slash']" />
                      </span>
                      {{ node.label }}
                    </label>
                  </treeselect>
                </div>

              </div>

              <div class="form-row">
                <div class="col">
                  <div class="headinfos">
                    <h3 v-if="isAfterSales">{{ $t('Webportal.Dashboard.Lambo.AfterSalesPerformance') }}<br/>({{$t('Webportal.Kpi')}} {{$t('Webportal.Overview')}})</h3>
                    <h3 v-else>{{ $t('Webportal.Dashboard.Lambo.SalesPerformance') }}<br/>({{$t('Webportal.Kpi')}} {{$t('Webportal.Overview')}})</h3>
                  </div>
                </div>

                <div class="col-auto col-md-auto">
                  <exportelementbutton elementRef="cockpit" right
                                       :additionalElements="[{ Name: $t('Webportal.Dashboard.Export.IncludeFilter'),
                                                               ElementRef: 'cockpit-and-filter' }]"
                                       fileName="Cockpit"
                                       :disabled="showPlaceholder || isLoading" />
                </div>
              </div>
            </div>

            <div ref="cockpit" v-bind:class="{ spinner: isLoading }">
              <div class="card-body">
                <dashboardpanel v-if="!showPlaceholder && !isLoading"
                                :dashdata="dashdata"
                                :selection="selection">
                </dashboardpanel>

                <div class="emptyplacehold" v-if="showPlaceholder && !isLoading">
                  {{ $t('Webportal.NoDataFound')}}
                </div>

                <div class="emptyplacehold" v-if="isLoading">
                  {{ $t('Webportal.Dashboard.Loading')}}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <b-modal ref="modalTooMuchWaves" id="modal-center" centered :title="$t('Webportal.Dashboard.Dialog.MaxWaves.Title')">
      <p class="my-4">{{ $t('Webportal.Dashboard.Dialog.MaxWaves.Text') }}</p>
      <div slot="modal-footer" class="w-100">
        <b-btn size="sm" class="float-right" variant="primary" @click="closeInfoDialog">
          {{ $t('Webportal.Dashboard.Ok') }}
        </b-btn>
      </div>
    </b-modal>
  </div>

</template>


<script>
  import axios from 'axios'
  import EventBus from '@/services/EventBus.js'
  import DashboardService from '@/services/DashboardService-APP_TARGET'
  import dashboardpanel from '@/components/Dashboard-APP_TARGET/DashboardPanel'
  import exportelementbutton from './ExportElementButton'
  import moment from "moment";
  import LocalizationChangedWithFilter from '@/mixins/LocalizationChangedWithFilter';

  export default {
    name: "Dashboard",

    mixins: [ LocalizationChangedWithFilter ],

    components:{
      dashboardpanel,
      exportelementbutton
    },

    mounted(){
      this.getOptions('mounted');
      EventBus.$on('LocalizationChanged', this.localizationChanged);
    },

    beforeDestroy() {
      EventBus.$off('LocalizationChanged', this.localizationChanged);
    },

    data() {
      return {
        filterRank: [
          'Surveys',
          'Waves',
          'Brand',
          'Country',
          'Region',
          'HoldingGroupName',
          'DealerCode',
          'DealerService',
          'Area',
          'PrIDE',
          'ClientLocations'
        ],

        selection: {
          Surveys : null,
          Waves : [],
          Brand:[],
          Country : [],
          Region : [],
          HoldingGroupName : [],
          DealerCode : [],
          DealerService : [],
          Area: [],
          PrIDE : [],
          ClientLocations : [],
        },

        optionState: {
          Surveys : false,
          Waves : false,
          Brand:false,
          Country : false,
          Region : false,
          HoldingGroupName : false,
          DealerCode : false,
          DealerService : false,
          Area: false,
          PrIDE : false,
          ClientLocations : false,
        },

        currentFilter: null,
        isLoading: false,

        cockpitCancelToken: null,
        optionsCancelToken: null,
        options2CancelToken: null,

        dashdata: [],
        optionsdata: {
          Surveys : [],
          Waves : [],
          Brand: [],
          Country: [],
          Region: [],
          HoldingGroupName: [],
          DealerCode: [],
          DealerService: [],
          Area: [],
          PrIDE: [],
          ClientLocations: [],
        },
        settingOptions: false,
        itemsLock: false,

        toolTipDelay: { delay: { "show": 500, "hide": 100 } }
      }
    },

    methods: {
      closeInfoDialog() {
        this.$refs.modalTooMuchWaves.hide();
      },
      
      getLocationActiveText() {
        return this.$t('Webportal.Location') + ' ' + this.$t('Webportal.Active');
      },
      getLocationInactiveText() {
        return this.$t('Webportal.Location') + ' ' + this.$t('Webportal.Inactive');
      },

      handleSurveyInput(value, instanceId) {
        if (this.isLoading || this.itemsLock) {
          return;
        }

        // Reset whole selection on survey change
        this.selection.Waves = [];
        this.selection.Brand = [];
        this.selection.Country = [];
        this.selection.Region = [];
        this.selection.HoldingGroupName = [];
        this.selection.DealerCode = [];
        this.selection.DealerService = [];
        this.selection.Area = [];
        this.selection.ClientLocations = [];

        this.loadData(value, instanceId);
      },

      handleInput(value, instanceId) {
        if (this.isLoading || this.itemsLock) {
          return;
        }

        switch (instanceId) {
          default:
            let obj = _.get(this.optionState, instanceId, undefined);
            if (obj === undefined) return;
            if (!value || value.length === 0) _.set(this.optionState, instanceId, true);
            if (obj === undefined) return;
            if (_.size(value) === 0) this.loadData(value, instanceId);
            break;
        }
      },

      handleClose(value, instanceId) {
        switch (instanceId) {
          case 'Surveys':
            this.itemsLock = true;
            this.selection.Waves = [];
            this.handleCloseGeneric(value, instanceId);
            this.itemsLock = false;
            break;
          case 'Waves':
            if (this.selection.Waves.length > 6) {
              this.selection.Waves = this.selection.Waves.slice(0, 6);
              this.$refs.modalTooMuchWaves.show();
            }
            this.handleCloseGeneric(value, instanceId);

          default:
            this.handleCloseGeneric(value, instanceId);
            break;
        }
      },

      handleCloseGeneric(value, instanceId) {
        let obj = _.get(this.optionState, instanceId, undefined);
        if (!obj) return;
        this.loadData(value, instanceId)
        _.set(this.optionState, instanceId, false);
      },

      handleSelect(node, instanceId) {
        let obj = _.get(this.optionState, instanceId, undefined);
        if (obj === undefined) return;
        _.set(this.optionState, instanceId, true);
      },

      handleDeselect(node, instanceId) {
        let obj = _.get(this.optionState, instanceId, undefined);
        if (obj === undefined) return;
        _.set(this.optionState, instanceId, true);
      },

      // Applies changed filter and triggeres data loading if necessary
      loadData(value, id) {
        let fltr = this.filterProperty(this);
        if (!_.isEqual(fltr, this.currentFilter)) {

          // iterate over all items in 'filterRank' starting with index + 1 of
          // actually changed item and set them to empty []
          // and skip first two items (Surveys and Waves)
          // prevent reload during operation with a bool lock
          this.itemsLock = true;
          if (_.indexOf(this.filterRank, id) > 1) {
            for (var i = _.indexOf(this.filterRank, id) + 1; i < this.filterRank.length; i++) {
              _.set(this.selection, this.filterRank[i], []);
            }
          }
          this.itemsLock = false;

          this.currentFilter = this.filterProperty(this);
          this.getOptions(id);
        }
      },

      // Get survey structure data for the structure treeselect
      getDashboard(_this) {
        var fltr = _this.filterProperty(_this);

        // Cancel previous request
        if (_this.cockpitCancelToken) {
          _this.cockpitCancelToken.cancel()
        }

        _this.cockpitCancelToken = axios.CancelToken.source()

        _this.isLoading = true
        DashboardService.getDashboard(fltr, _this.cockpitCancelToken)
          .then(response => {
            _this.dashdata = response.data
            _this.isLoading = false
            })
          .catch((thrown) => {
            _this.isLoading = false
          });
      },

      filterWaves(_this, opt) {
        if (!_this || !opt || !_this.selection || !_this.selection.Surveys) return;
        let selected = _this.selection.Surveys;
        _.remove(opt.Waves, function(wave) {
          return selected.id !== wave.SurveyId;
        });
      },

      setOptions(_this, sender, opt) {
        _this.settingOptions = true;

        if (!opt.Surveys) opt.Surveys = '';
        if (opt.Surveys.length > 0 && _this.selection.Surveys == null) {
          _this.selection.Surveys = _.first(opt.Surveys);
        }
        if (!opt.Waves) opt.Waves = [];
        if (_this.selection.Surveys) {
           _this.filterWaves(_this, opt);
        }

        if (!opt.Brand) opt.Brand = [];
        if (!opt.Country) opt.Country = [];
        if (!opt.Region) opt.Region = [];
        if (!opt.HoldingGroupName) opt.HoldingGroupName = [];
        if (!opt.DealerCode) opt.DealerCode = [];
        if (!opt.DealerService) opt.DealerService = [];
        if (!opt.Area) opt.Area = [];
        if (!opt.PrIDE) opt.PrIDE = [];
        if (!opt.ClientLocations) opt.ClientLocations = [];

        if (sender === 'mounted' || _this.selection.Waves.length === 0) {
          // Preselect Waves
          if (opt.Waves.length > 0) {
            this.setWaveSelection(_this, opt);
          }
        }

        // if only one option exists, ensure it is selected
        // opt.XYZ[0].ClientLocationCount === opt.XYZ[0].TotalClientLocationCount ... prevents an auto-select for
        // not fully filled datasets
         if (opt.Brand.length === 1 && _this.selection.Brand.length === 0 &&
            opt.Brand[0].ClientLocationCount === opt.Brand[0].TotalClientLocationCount) {
          _this.selection.Brand.push(opt.Brand[0].id); }
       
        if (opt.Country.length === 1 && _this.selection.Country.length === 0 && opt.Country[0].label !== '' &&
            opt.Country[0].ClientLocationCount === opt.Country[0].TotalClientLocationCount) {
          _this.selection.Country.push(opt.Country[0].id); }
        if (opt.Region.length === 1 && _this.selection.Region.length === 0 && opt.Region[0].label !== '' &&
            opt.Region[0].ClientLocationCount === opt.Region[0].TotalClientLocationCount) {
          _this.selection.Region.push(opt.Region[0].id); }
        if (opt.HoldingGroupName.length === 1 &&  _this.selection.HoldingGroupName.length === 0 && opt.HoldingGroupName[0].label !== '' &&
            opt.HoldingGroupName[0].ClientLocationCount === opt.HoldingGroupName[0].TotalClientLocationCount) {
          _this.selection.HoldingGroupName.push(opt.HoldingGroupName[0].id); }
        if (opt.DealerCode.length === 1 && _this.selection.DealerCode.length === 0 && opt.DealerCode[0].label !== '' &&
            opt.DealerCode[0].ClientLocationCount === opt.DealerCode[0].TotalClientLocationCount) {
          _this.selection.DealerCode.push(opt.DealerCode[0].id); }
        if (opt.DealerService.length === 1 && _this.selection.DealerService.length === 0 && opt.DealerService[0].label !== '' &&
          opt.DealerService[0].ClientLocationCount === opt.DealerService[0].TotalClientLocationCount) {
          _this.selection.DealerService.push(opt.DealerService[0].id); }
        if (opt.Area.length === 1 && _this.selection.Area.length === 0 && opt.Area[0].label !== '' &&
          opt.Area[0].ClientLocationCount === opt.Area[0].TotalClientLocationCount) {
          _this.selection.Area.push(opt.Area[0].id); }
        if (opt.PrIDE.length === 1 && _this.selection.PrIDE.length === 0 && opt.PrIDE[0].label !== '' &&
          opt.PrIDE[0].ClientLocationCount === opt.PrIDE[0].TotalClientLocationCount) {
          _this.selection.PrIDE.push(opt.PrIDE[0].id); }
        if (opt.ClientLocations.length === 1 && _this.selection.ClientLocations.length === 0 && opt.ClientLocations[0].label !== '' &&
          opt.ClientLocations[0].ClientLocationCount === opt.ClientLocations[0].TotalClientLocationCount) {
          _this.selection.ClientLocations.push(opt.ClientLocations[0].id); }

        _this.optionsdata = opt;
        _this.settingOptions = false;
      },

      setWaveSelection(_this, opt) {
        let lastYearInList = _.max(_.map(opt.Waves, function(w) { return moment(w.WaveDate, moment.ISO_8601).year()}));
        if (lastYearInList > moment().year()) { lastYearInList = moment().year(); }
        let areAllWavesSelected = _.every(opt.Waves, function(wave) {
          return wave.IsDefault !== 1 &&
                 moment(wave.WaveDate, moment.ISO_8601).year() === lastYearInList;
        });
        if (areAllWavesSelected)
          return;

        let newWaves = [];
        opt.Waves.forEach(wave => {
          if (wave.IsDefault === 1 && moment(wave.WaveDate, moment.ISO_8601).year() === lastYearInList)
            newWaves.push(wave.id);
        });
        _this.selection.Waves = newWaves;
      },

      getOptions(sender) {
        var _this = this;

        _this.isLoading = true;

        if (sender !== 'mounted') {
           // Cancel previous request
          if (_this.optionsCancelToken) _this.optionsCancelToken.cancel();
          _this.optionsCancelToken = axios.CancelToken.source();

          DashboardService.getOptions(_this.currentFilter).then(response => {
            _this.setOptions(_this, sender, response.data);
            _this.currentFilter = _this.filterProperty(_this);
            _this.getDashboard(_this);
          });

          return;
        } else {
          // Cancel previous request
          if (_this.optionsCancelToken) _this.optionsCancelToken.cancel();
          _this.optionsCancelToken = axios.CancelToken.source();

          DashboardService.getOptions(_this.currentFilter).then(response => {
            _this.setOptions(_this, sender, response.data);

            if (sender === 'mounted') {

              if (_this.options2CancelToken) _this.options2CancelToken.cancel();
              _this.options2CancelToken = axios.CancelToken.source();
              _this.currentFilter = _this.filterProperty(_this);

              DashboardService.getOptions(_this.currentFilter).then(response => {
                _this.setOptions(_this, sender, response.data);
                _this.currentFilter = _this.filterProperty(_this);
                _this.getDashboard(_this);
              });
            }
          });
        }
      },

      getOverallItem: function (name) {
        var _this = this
        if (_this.dashdata && _this.dashdata.Overall && _.size(_this.dashdata.Overall) > 0)
          return _.findLast(_this.dashdata.Overall, (x) => x)
      },

      filterProperty(_this) {
        let contact = null;

        let result = {
          surveys:            _this.selection.Surveys.id,
          waves:              _.join(_this.selection.Waves, ','),
          brand:              _.join(_this.selection.Brand, '|'),
          country:            _.join(_this.selection.Country, '|'),
          region:             _.join(_this.selection.Region, '|'),
          holdinggroupname:   _.join(_this.selection.HoldingGroupName, '|'),
          dealercode:         _.join(_this.selection.DealerCode, '|'),
          dealerservice:      _.join(_this.selection.DealerService, '|'),
          area:               _.join(_this.selection.Area, '|'),
          clientlocations:    _.join(_this.selection.ClientLocations, ',') // muss CSV übergeben werden
        };
        return result;
      }
    },

    computed: {
      isAfterSales: function() {
        if(!this.dashdata || !this.optionsdata || !this.optionsdata.Surveys || !this.selection.Surveys) {
          return false;
        }
        return this.selection.Surveys.label.startsWith('Lamborghini Aftersales');
      },

      showPlaceholder: function() {
        return !this.dashdata || !this.selection.Surveys || !this.dashdata.KPI;
      },

      hasOptions: function() {
        return this.selection.Surveys && !_.isEmpty(this.optionsdata);
      },

      isWaveFilterEnabled: function() {
        return this.hasOptions && this.optionsdata.Waves && this.optionsdata.Waves.length > 0;
      },

      isCountryFilterEnabled: function() {
        return this.hasOptions && this.optionsdata.Country && this.optionsdata.Country.length > 0;
      },

      isRegionFilterEnabled: function() {
        return this.hasOptions && this.optionsdata.Region && this.optionsdata.Region.length > 0;
      },

      isHoldingGroupNameFilterEnabled : function() {
        return this.hasOptions && this.optionsdata.HoldingGroupName && this.optionsdata.HoldingGroupName.length > 0;
      },

      isDealerCodeFilterEnabled: function() {
        return this.hasOptions && this.optionsdata.DealerCode && this.optionsdata.DealerCode.length > 0;
      },

      isDealerServiceFilterEnabled: function() {
        return this.hasOptions && this.optionsdata.DealerService && this.optionsdata.DealerService.length > 0;
      },

      isAreaFilterEnabled: function() {
        return this.hasOptions && this.optionsdata.Area && this.optionsdata.Area.length > 0;
      },

      isPrIDEFilterEnabled: function() {
        return this.hasOptions && this.optionsdata.PrIDE && this.optionsdata.PrIDE.length > 0;
      },

      isClientLocationsFilterEnabled: function() {
        return this.hasOptions && this.optionsdata.ClientLocations && this.optionsdata.ClientLocations.length > 0;
      },
    }
  }

</script>

<style lang="scss" scoped>
  @import "@/../scss/lambo/variables.scss";

.emptyplacehold{
  width: 100%;
  height: 200%;
  text-align: center;
  margin-top: 7em;
}

.container{
  margin-left: 0px;
  margin-right: 0px;
  padding-left: 0px;
  padding-right: 0px;
  max-width: 100%;
  width: 100%;
}

.card{
  margin-bottom: 20px;
  word-wrap: unset;
}

.card-body{
  min-height: 150px;
}

  selected {
    color: $lambo-nav-selected;
  }

  .headinfos{
    display: inline-block;
    width: 100%;
  }

  .bottomline {
    bottom: 0px;
  }

  .navListBorder {
    width: 120px;
    float: right;
    bottom: 0px;
    -webkit-padding-start: 0px;
    border-top: 2px solid $lambo-nav-border;
    border-left: 2px solid $lambo-nav-border;
  }

  .navLineBorder {
    float: right;
    bottom: 0px;
    width: 400px;
    -webkit-padding-start: 0px;
    border-top: 2px solid $lambo-nav-border;
    border-left: 2px solid $lambo-nav-border;
  }

  nav ul {
    list-style-type: none;
    font-size: 11pt;
    font-weight: bold;
    margin-bottom: 0px;
    margin-top: 6px;
    -webkit-padding-start: 12px;

    color: $lambo-nav-color;
  }
  .customerlogo{
    float: right;
    right: 0px;
    bottom: 0px;
    margin: 6px;
    margin-top:0px;
    margin-bottom: 7.5px;
  }
  .rightMenu {
    float: right;
    width: auto;
  }

  h3 {
    color: $lambo-h3;
    margin-bottom: 0px;
    font-size: 16pt;
    float: left;
    font-stretch: extra-condensed;
  }

</style>
